import React from "react";
import { ReactComponent as Logo } from '../assets/logo.svg';
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from "react-icons/fa";

const Footer = () => {
	const redes = [
		{ icon: FaWhatsapp, url: "https://api.whatsapp.com/send/?phone=522221225330&text&type=phone_number&app_absent=0" },
		{ icon: FaFacebook, url: "https://www.facebook.com/profile.php?id=100069811171812#" },
		{ icon: FaInstagram, url: "https://www.instagram.com/expertcwgo/?hl=es-la" },
		{ icon: FaLinkedin, url: "https://www.linkedin.com/in/expert-cleaning-washgo-a26752214/" },
	];

	return (
		<footer className="h-fit w-full grid grid-cols-1 p-4 bg-sky-700 shadow text-white">
			<div className="grid grid-cols-2 md:grid-cols-4">
				<div className="w-full flex justify-center items-center">
					<Logo className="w-44"/>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> Contactanos </h2>
					<strong>Horarios: 9:00 AM - 8:00 PM</strong>
					<p> +52 222 863 0029 </p>
					<p> expertcwgo@gmail.com </p>
				</div>
				<div className="grid place-items-center gap-2">
					<h2> DIRECCIÓN </h2>
					<p>
						{" "}
						51 Poniente, No.1110 Loc. 2L, Prados Agua Azul, Heroica Puebla de Zaragoza, México, C.P. 72430.
						{" "}
					</p>
				</div>
				<div className="flex flex-row justify-center gap-8 py-8">
					{redes.map((red, index) => {
						const Icon = red.icon;
						return (
							<a
								key={index}
								href={red.url}
								target="_blank"
								rel="noopener noreferrer"
								aria-label={red.name}
								className="text-white text-2xl hover:text-white transition-colors"
							>
								<Icon />
							</a>
						);
					})}
				</div>
			</div>
		</footer>
	);
};

export default Footer;
